import React, { memo } from 'react'
import { Trans } from 'react-i18next'
import { Link as MuiLink } from '@mui/material'

import NotificationBar from '../../components/authorizedLayout/NotificationBar'
import { STAKING_APY } from '../../util/staking/staking.helpers'

const ConnectWalletNotification = ({
  onWalletClick,
  symbol,
  notifyRef,
  connectedWallet,
  onBannerAction
}) => {
  const linkParams = connectedWallet
    ? {
        onClick: onBannerAction
      }
    : { onClick: onWalletClick }
  return (
    <NotificationBar
      notifyRef={notifyRef}
      message={
        <Trans
          i18nKey={
            connectedWallet
              ? 'notification.no-qbx-top-desc'
              : 'notification.no-connect-wallet'
          }
          values={{ symbol, apy: STAKING_APY }}
        >
          <MuiLink
            sx={{
              color: 'inherit',
              cursor: 'pointer',
              textDecoration: 'underline'
            }}
            {...linkParams}
          />
        </Trans>
      }
    />
  )
}

export default memo(ConnectWalletNotification)
